'use client';
import { cn } from '@skin-seoul/design-system';
import { forwardRef } from 'react';
import { VerticalProductCardSkeleton } from '../../components/ProductCard';

export const ProductGrid = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'grid grid-cols-2 desktop:grid-cols-5 w-full min-h-[344px] gap-3 desktop:gap-4',
        '[&>*:nth-child(n+5)]:hidden desktop:[&>*:nth-child(n+5)]:block',
        className,
      )}
      {...props}
    />
  ),
);

export const ProductGridSkeleton = ({ length = 5 }: { length?: number }) => {
  return (
    <ProductGrid>
      {Array.from({ length }).map((_, index) => (
        <div key={index} className="min-w-0">
          <VerticalProductCardSkeleton width="100%" />
        </div>
      ))}
    </ProductGrid>
  );
};
